import $ from 'jquery'

$(document).ready(function() {
  co_vc_lieferoptionen()
})

function co_vc_lieferoptionen() {
  $('.co_vc_lieferoptionen').each(function() {})
}
